var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',_vm._l((_vm.features),function(feature){return _c('GridItem',{key:feature,attrs:{"gridSpan":4}},[_c('HeadingSmall',{class:_vm.$style.feature,attrs:{"weight":"normal"}},[_c('Icon',{attrs:{"icon":"checkmarkCircle","inline":true}}),_vm._v(" "+_vm._s(feature)+" ")],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }